__turbopack_context__.v({
  "action": "jxREzq_action",
  "actionLabel": "jxREzq_actionLabel",
  "icon": "jxREzq_icon",
  "imageContainer": "jxREzq_imageContainer",
  "isInactive": "jxREzq_isInactive",
  "previewButton": "jxREzq_previewButton",
  "searchIcon": "jxREzq_searchIcon",
  "text": "jxREzq_text",
  "wrapper": "jxREzq_wrapper",
});
